import { useQuery } from '@tanstack/react-query'
import { providerApiClient } from '@/lib/api'
import { recordingKeys } from '@/lib/queryKeys'

export function useRecordings(filters?: { status?: string }) {
  return useQuery({
    queryKey: recordingKeys.list(filters),
    queryFn: () => providerApiClient.getRecordings(filters),
    staleTime: 5 * 60 * 1000,
  })
}

export function useRecordingNotes(recordingId: string | undefined) {
  return useQuery({
    queryKey: recordingKeys.notes(recordingId ?? ''),
    queryFn: () => providerApiClient.getRecordingNotes(recordingId ?? ''),
    enabled: !!recordingId,
    staleTime: 5 * 60 * 1000,
  })
}
